import { render, staticRenderFns } from "./cutScheme.vue?vue&type=template&id=5edfa4ba&"
import script from "./cutScheme.vue?vue&type=script&lang=js&"
export * from "./cutScheme.vue?vue&type=script&lang=js&"
import style0 from "./cutScheme.vue?vue&type=style&index=0&id=5edfa4ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports